module.exports = __webpack_public_path__ + "img/logo.ce88ddea.jpeg";